"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var UserBackSignUp = function (_a) {
    var backToForm = _a.backToForm;
    var t = (0, next_intl_1.useTranslations)('translation');
    var closeModal = (0, apps_shared_1.useCloseModal)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.imageWrapper },
            react_1.default.createElement("img", { className: styles_module_scss_1.default.userBackIcon, src: "/img/signup/user-back.svg", alt: "back" })),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('userBackSignUpTitle')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, t('userBackSignUpDescription')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", onClick: backToForm }, t('back'))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.closeButtonWrapper },
            react_1.default.createElement(ui_components_1.FixedButton, { color: "blue", onClick: closeModal, variant: "outline", text: "upper" }, t('close')))));
};
exports.default = UserBackSignUp;
